var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.44,10.48,9,6.74a.57.57,0,0,0-.59,0,.58.58,0,0,0-.3.52v7.49a.57.57,0,0,0,.3.51.52.52,0,0,0,.3.08.56.56,0,0,0,.3-.08l6.48-3.74a.6.6,0,0,0,0-1Zm-1.5.52L9.26,13.71V8.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,8.6a8.65,8.65,0,0,1,.35,2.4,8.43,8.43,0,1,1-4.7-7.52,4.19,4.19,0,0,1,.46-1.11,9.48,9.48,0,0,0-4.15-1A9.59,9.59,0,1,0,20.59,11a9.35,9.35,0,0,0-.39-2.66A3.77,3.77,0,0,1,19,8.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.4,2.48a.31.31,0,0,0-.33.33.35.35,0,0,0,.07.23.32.32,0,0,0,.26.11,3.43,3.43,0,0,1,3.37,3.36h0a.19.19,0,0,0,0,.08v.22h.12l0,.06.14,0a.38.38,0,0,0,.27-.11.35.35,0,0,0,.07-.23A4,4,0,0,0,16.4,2.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.43,3.9a.32.32,0,0,0-.34.34.33.33,0,0,0,.11.26.35.35,0,0,0,.23.07,2,2,0,0,1,2,2l0,.11.23.22.11,0A.37.37,0,0,0,19,6.74a.41.41,0,0,0,.07-.22A2.62,2.62,0,0,0,16.43,3.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.43,5.25a.38.38,0,0,0-.23.07.36.36,0,0,0,0,.52.36.36,0,0,0,.23.08.62.62,0,0,1,.59.6l0,.09.08.11.21.13.06,0a.33.33,0,0,0,.23-.09.35.35,0,0,0,.09-.25A1.26,1.26,0,0,0,16.43,5.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIconWhite);
export default __webpack_public_path__ + "static/media/manual-icon-white.3be038bd4a9bd33e3e9826be3dc96d15.svg";
export { ForwardRef as ReactComponent };